import { squarePlus } from "@/components/icons/SVGIcons";
import workspacesTabsStore from "@/store/workspacesTabsStore";
import { addNewWorkspaceTabToUser } from "@/store/workspacesTabsStoreACTIONS";
import React from "react";
import { toast } from "react-toastify";
import ToolTipMappedSVGandButton from "./ToolTipMappedSVGandButton";

const AddNewWorkspaceButton = ({
  getAccessTokenSilently,
}: {
  getAccessTokenSilently: Function;
}) => {
  const tabNamesAndActive = workspacesTabsStore(
    (state) => state.tabNamesAndActive,
  );
  function addNewWorkspaceTabOnClick() {
    if (tabNamesAndActive.length >= 6) {
      toast.error("Maximum amount of tabs already created.");
    } else {
      addNewWorkspaceTabToUser(getAccessTokenSilently);
    }
  }

  const buttonDetails = {
    displayName: "Add",
    icon: squarePlus,
  };

  return (
    <ToolTipMappedSVGandButton
      button={buttonDetails}
      onClickAction={addNewWorkspaceTabOnClick}
      dataTestID={"Add"}
    />
  );
};

export default AddNewWorkspaceButton;
